import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Users, ClipboardList, Clock, CheckCircle, AlertTriangle } from "lucide-react";

export default function AgentDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getAgentStats().then(setStats).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-gray-400">Loading...</div>;

  const cards = [
    { label: "Assigned Customers", value: stats?.total_customers || 0, icon: Users, bg: "bg-blue-50", text: "text-blue-600" },
    { label: "Total Executions", value: stats?.total_executions || 0, icon: ClipboardList, bg: "bg-emerald-50", text: "text-emerald-600" },
    { label: "Pending Review", value: stats?.pending_review || 0, icon: Clock, bg: "bg-amber-50", text: "text-amber-600" },
    { label: "Under Review", value: stats?.under_review || 0, icon: AlertTriangle, bg: "bg-orange-50", text: "text-orange-600" },
    { label: "Approved", value: stats?.approved || 0, icon: CheckCircle, bg: "bg-green-50", text: "text-green-600" },
  ];

  return (
    <div data-testid="agent-dashboard">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Agent Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.label} data-testid={`agent-stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}
            className="bg-white border border-gray-200 rounded-xl p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${c.bg} ${c.text}`}>
                <c.icon className="w-5 h-5" />
              </div>
              <span className="text-sm text-gray-500">{c.label}</span>
            </div>
            <p className="text-3xl font-bold text-gray-900">{c.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
